import fetch from '../../../../core/fetch';
import showToaster from '../../../../helpers/toasterMessages/showToaster';

async function submit(values, dispatch) {
  const query = `
  mutation (
    $workTitleHeading: String,
    $workTitleHeading_en: String,
    $workTitleHeading_fr: String,
    $workTitleHeading_it: String,
    $workTitleHeading_pt: String,
    $peaceTitle1: String,
    $peaceTitle1_en: String,
    $peaceTitle1_fr: String,
    $peaceTitle1_it: String,
    $peaceTitle1_pt: String,
    $peaceTitle2: String,
    $peaceTitle2_en: String,
    $peaceTitle2_fr: String,
    $peaceTitle2_it: String,
    $peaceTitle2_pt: String,
    $peaceContent1: String,
    $peaceContent1_en: String,
    $peaceContent1_fr: String,
    $peaceContent1_it: String,
    $peaceContent1_pt: String,
    $peaceContent2: String,
    $peaceContent2_en: String,
    $peaceContent2_fr: String,
    $peaceContent2_it: String,
    $peaceContent2_pt: String,
    $workImage4: String
) {
  updateWhyHostPage (
    workTitleHeading: $workTitleHeading,
    workTitleHeading_en: $workTitleHeading_en,
    workTitleHeading_fr: $workTitleHeading_fr,
    workTitleHeading_it: $workTitleHeading_it,
    workTitleHeading_pt: $workTitleHeading_pt,
    peaceTitle1: $peaceTitle1,
    peaceTitle1_en: $peaceTitle1_en,
    peaceTitle1_fr: $peaceTitle1_fr,
    peaceTitle1_it: $peaceTitle1_it,
    peaceTitle1_pt: $peaceTitle1_pt,
    peaceTitle2: $peaceTitle2,
    peaceTitle2_en: $peaceTitle2_en,
    peaceTitle2_fr: $peaceTitle2_fr,
    peaceTitle2_it: $peaceTitle2_it,
    peaceTitle2_pt: $peaceTitle2_pt,
    peaceContent1: $peaceContent1,
    peaceContent1_en: $peaceContent1_en,
    peaceContent1_fr: $peaceContent1_fr,
    peaceContent1_it: $peaceContent1_it,
    peaceContent1_pt: $peaceContent1_pt,
    peaceContent2: $peaceContent2,
    peaceContent2_en: $peaceContent2_en,
    peaceContent2_fr: $peaceContent2_fr,
    peaceContent2_it: $peaceContent2_it,
    peaceContent2_pt: $peaceContent2_pt,
    workImage4: $workImage4
  ) {
      status
  }
}

  `;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables: values
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();

  if (data.updateWhyHostPage.status === "success") {
    showToaster({ messageId: 'updateWhyHostPage', toasterType: 'success'})
  } else {
    showToaster({ messageId: 'updateWhyHostPageFailed', toasterType: 'error'})
  }

}

export default submit;
